
import {
    Card,
    CardContent,
    CardHeader,
    Grid,
    MenuItem,
    TextField,
  } from '@material-ui/core';
  import 'date-fns';
  import { green, red } from '@material-ui/core/colors';
  import { makeStyles } from '@material-ui/styles';
  import React, { useEffect, useState } from 'react';
  import 'react-confirm-alert/src/react-confirm-alert.css';
  import { useTranslation } from 'react-i18next';
  import 'react-phone-input-2/lib/style.css';
  import Autocomplete from '@material-ui/lab/Autocomplete';
  import ReactFlagsSelect from 'react-flags-select';
  import axios from 'src/utils/axios';
  import {
      getUser
    } from 'src/utils/Common';
  
      const useStyles = makeStyles(theme => ({
          rootTopBar: {
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          paddingTop: 20,
          paddingLeft: 20,
          paddingBottom: 20,
          paddingRight: 20
          },
          fabGreen: {
          position: "fixed",
          bottom: theme.spacing(2),
          right: theme.spacing(2),
          color: theme.palette.common.white,
          backgroundColor: green[500],
          "&:hover": {
              backgroundColor: green[600]
          }
          },
          inputTopBar: {
          marginLeft: theme.spacing(1),
          flex: 1
          },
          iconButtonTopBar: {
          padding: 10
          },
          dividerTopBar: {
          height: 28,
          margin: 4
          },
          cover: {
          height: '140'
          },
          avatarAtanan: {
          backgroundColor: red[500]
          },
          avatar1Atanan: {
          backgroundColor: green[500]
          },
          valueAtanan: {
          fontWeight: theme.typography.fontWeightMedium
          },
          typeAtanan: {
          fontWeight: theme.typography.fontWeightMedium
          },
          searchAtanan: {
          flexGrow: 1,
          height: 42,
          padding: theme.spacing(0, 2),
          display: 'flex',
          alignItems: 'center'
          },
          searchIconAtanan: {
          marginRight: theme.spacing(2),
          color: theme.palette.icon
          },
          searchInputAtanan: {
          flexGrow: 1
          },
          pageStyleAtanan: {
          display: 'flex',
          padding: '2px 4px'
          },
          inputAtanan: {
          marginLeft: theme.spacing(1),
          flex: 1
          },
          iconButtonAtanan: {
          padding: 10
          },
          fieldsAtanan: {
          margin: theme.spacing(-1),
          display: 'flex',
          flexWrap: 'wrap',
          '& > *': {
              flexGrow: 1,
              margin: theme.spacing(1)
          }
          },
          backdrop: {
          zIndex: theme.zIndex.drawer + 1,
          color: '#fff'
          },
          actions: {
          justifyContent: 'flex-end'
          },
      
          cardscontent: {
          minHeight: 500,
          minWidth: 400
          },
          expand: {
          transform: 'rotate(0deg)',
          marginLeft: 'auto',
          transition: theme.transitions.create('transform', {
              duration: theme.transitions.duration.shortest
          })
          },
          expandOpen: {
          transform: 'rotate(180deg)'
          },
          cardsInfoMax: {
          // maxHeight: 230,
          minHeight: 200
          },
          cardsMax: {
          maxHeight: 230,
          minHeight: 230
          },
          cardsAssetMax: {
          maxHeight: 550,
          minHeight: 550
          },
          cardsContentMax: {
          maxHeight: 180,
          minHeight: 180
          },
          cardsMaxF: {
          // maxHeight: 230,
          minHeight: 350
          },
          cardsContentMax: {
          maxHeight: 180,
          minHeight: 150
          },
          cardsContentMaxF: {
          // maxHeight: 180,
          minHeight: 300
          },
      
          cardscontent: {
          minHeight: 350
          },
          cards: {
          minHeight: 500
          // maxHeight: 500,
          },
          root: {
          flexGrow: 1
          },
          paper: {
          padding: theme.spacing(2),
          textAlign: 'center',
          color: theme.palette.text.secondary
          },
          root: {
          flexGrow: 1
          },
          paper: {
          padding: theme.spacing(2),
          textAlign: 'center',
          color: theme.palette.text.secondary
          },
          cardArddress: {
          minHeight: 340,
          maxHeight: 340
          }
      }));
  
      function ServiceShopBillTo({
        serviceAddressData
       }){
          const classes = useStyles();
          const { t } = useTranslation('overview');

          const [AddressTypes, setAddressTypes] = useState([]);
          const [RegionData2, setRegionData2] = useState([]);
          const [CityData2, setCityData2] = useState([]);
          const [DistrictData2, setDistrictData2] = useState([]);
          const SessionUser = getUser();
          const locale = localStorage.getItem('i18nextLng');

          const [stateAddress, setStateAddress] = React.useState({
              StateScreen: true,
              RegionScreen: true,
              ApartmentScreen: true,
              DoorNrScreen: true,
              PostCodeScreen: true,
              LongitudeScreen: true,
              LatitudeScreen: true
            });
          const {
              StateScreen,
              RegionScreen,
              ApartmentScreen,
              DoorNrScreen,
              PostCodeScreen,
          } = stateAddress;

          const GetAddressTypes = () => {
            axios
              .get(`/GetAddressTypes`)
              .then(response => {
                if (response.data.length > 0) {
                  setAddressTypes(response.data);
                }
              })
              .catch(error => { });
          };

          useEffect(() => {
            GetAddressTypes();
        }, [locale]);
          
  
          return (
              <Grid item xs={12} sm={12} lg={12}>
                  <Card className={classes.cards}>
                      <CardContent className={classes.cardscontent}>
                          <Grid container spacing={2}>
                              <Grid item xs={12} sm={6} lg={6}>
                              <ReactFlagsSelect
                                  disabled
                                  size="small"
                                  selected={serviceAddressData?.Country}
                                  searchable
                                  id="Country"
                                  name="Country"
                              />
                              </Grid>
                              <Grid item xs={12} sm={6} lg={6}>
                              <TextField
                                  disabled
                                  size="small"
                                  fullWidth
                                  select
                                  autoComplete="no"
                                  id="AddressTypeId"
                                  label={t('lblAddressType')}
                                  value={serviceAddressData?.ConsumerAddressTypeId} 
                                  variant="outlined"
                              >
                                  {AddressTypes.map(p => {
                                  return (
                                      <MenuItem key={p.Id} value={p.Id}>
                                      {p.Dsc}
                                      </MenuItem>
                                  );
                                  })}
                              </TextField>
                              </Grid>
                              <Grid item xs={12} sm={12} lg={12}>
                              <TextField
                                  disabled
                                  size="small"
                                  id="Name"
                                  autoComplete="no"
                                  value={serviceAddressData?.Name}
                                  fullWidth
                                  label={t('lblName')}
                                  variant="outlined"
                              />
                              </Grid>
                              <Grid item xs={12} sm={6} lg={6}>
                              <TextField
                                  disabled
                                  size="small"
                                  id="State"
                                  style={{ display: StateScreen ? '' : 'none' }}
                                  autoComplete="no"
                                  value={serviceAddressData?.State}
                                  fullWidth
                                  label={t('lblState')}
                                  variant="outlined"
                              />
                              </Grid>
                              {SessionUser.TenantId != 71 ?
                              <Grid item xs={12} sm={6} lg={6}>
                              <Autocomplete
                                  disabled
                                  size="small"
                                  fullWidth
                                  freeSolo
                                  autoSelect
                                  style={{ display: RegionScreen ? '' : 'none' }}
                                  value={serviceAddressData?.Region}
                                  options={RegionData2}
                                  renderInput={params => (
                                  <TextField
                                      {...params}
                                      label={t('lblRegion')}
                                      variant="outlined"
                                  />
                                  )}
                              />
                              </Grid> : null}
  
                              <Grid item xs={12} sm={6} lg={6}>
                              <Autocomplete
                                 disabled
                                  size="small"
                                  fullWidth
                                  freeSolo
                                  autoSelect
                                  value={serviceAddressData?.City}
                                  options={CityData2}
                                  renderInput={params => (
                                  <TextField
                                      {...params}
                                      label={t('lblCity')}
                                      variant="outlined"
                                  />
                                  )}
                              />
                              </Grid>
                              {SessionUser.TenantId != 71 ? 
                              <Grid item xs={12} sm={6} lg={6}>
                              <Autocomplete
                                  disabled
                                  size="small"
                                  fullWidth
                                  freeSolo
                                  autoSelect
                                  value={serviceAddressData?.District}
                                  id="controllable-states-distict"
                                  options={DistrictData2}
                                  getOptionLabel={option => option}
                                  renderInput={params => (
                                  <TextField
                                      {...params}
                                      label={t('lblDistrict')}
                                      variant="outlined"
                                  />
                                  )}
                              />
                              </Grid> : null}
                              {SessionUser.TenantId != 71 ?
                              <Grid item xs={12} sm={6} lg={6}>
                                <TextField
                                    disabled
                                    size="small"
                                    id="Neighborhood"
                                    autoComplete="no"
                                    value={serviceAddressData?.Neighborhood}
                                    fullWidth
                                    label={t('lblNeighborhood')}
                                    variant="outlined"
                                />
                              </Grid> : null}
                              <Grid item xs={12} sm={6} lg={6}>
                                <TextField
                                    disabled
                                    size="small"
                                    id="TaxId"
                                    autoComplete="no"
                                    value={serviceAddressData?.TaxId}
                                    fullWidth
                                    label={t('lblTaxId')}
                                    variant="outlined"
                                />
                              </Grid>
                              <Grid item xs={12} sm={12} lg={12}>
                                <TextField
                                    disabled
                                    size="small"
                                    id="Street"
                                    autoComplete="no"
                                    value={serviceAddressData?.Street}
                                    fullWidth
                                    label={t('lblStreet')}
                                    variant="outlined"
                                />
                              </Grid>
                              {SessionUser.TenantId != 71 ?
                              <Grid item xs={12} sm={6} lg={4}>
                              <TextField
                                disabled
                                  size="small"
                                  id="Apartment"
                                  style={{ display: ApartmentScreen ? '' : 'none' }}
                                  autoComplete="no"
                                  value={serviceAddressData?.Apartment}
                                  fullWidth
                                  label={t('lblApartment')}
                                  variant="outlined"
                              />
                              </Grid> : null}
                              <Grid item xs={12} sm={6} lg={4}>
                                <TextField
                                    disabled
                                    size="small"
                                    id="DoorNr"
                                    style={{ display: DoorNrScreen ? '' : 'none' }}
                                    autoComplete="no"
                                    value={serviceAddressData?.DoorNr}
                                    fullWidth
                                    label={t('lblDoorNr')}
                                    variant="outlined"
                                />
                                </Grid>
                              <Grid item xs={12} sm={6} lg={4}>
                                <TextField
                                      disabled
                                      size="small"
                                      id="PostCode"
                                      style={{ display: PostCodeScreen ? '' : 'none' }}
                                      autoComplete="no"
                                      value={serviceAddressData?.PostCode}
                                      fullWidth
                                      label={t('lblPostCode')}
                                      variant="outlined"
                                  />
                              </Grid>
                              <Grid item xs={12} sm={6} lg={12}>
                              <TextField
                                  disabled
                                  size="small"
                                  multiline
                                  rows={5}
                                  fullWidth
                                  id="AddressItem"
                                  autoComplete="no"
                                  value={serviceAddressData?.Address}
                                  label={t('lblAddress')}
                                  variant="outlined"
                              />
                              </Grid>
                          </Grid>
                      </CardContent>
                  </Card>
              </Grid>
          )
      }
  
export default ServiceShopBillTo;